var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleSheetsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 0H2.667A2.667 2.667 0 000 2.667v18.666A2.667 2.667 0 002.667 24h18.666A2.667 2.667 0 0024 21.333V2.667A2.667 2.667 0 0021.333 0z",
    fill: "#139F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.335 8.684v9.705a.947.947 0 01-.95.944H7.618a.947.947 0 01-.949-.944V5.61c0-.521.425-.944.949-.944H13.3l4.034 4.017z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.852 8.596l3.483 1.43V8.683l-1.975-.581-1.508.493z",
    fill: "#8492A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.335 8.684h-3.086a.947.947 0 01-.948-.945V4.667l4.034 4.017z",
    fill: "#E0E6ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.528 11.52h-4.666a.302.302 0 00-.303.302v4.044c0 .166.135.302.303.302h4.666a.302.302 0 00.303-.302v-4.044a.302.302 0 00-.303-.302zm-4.363 1.94h1.727v.767h-1.727v-.767zm2.333 0h1.727v.767h-1.727v-.767zm1.728-.603h-1.728v-.733h1.728v.733zm-2.334-.733v.733h-1.727v-.733h1.727zm-1.727 2.707h1.727v.733h-1.727v-.733zm2.333.733v-.733h1.727v.733h-1.727z",
    fill: "#139F5B"
  })));
}

export default __webpack_public_path__ + "./fonts/google-sheets-icon.6fce53887f17d1540f67fb1760cbfd13.svg";
export { SvgGoogleSheetsIcon as ReactComponent };